import React from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';

/**
 * Shared section card for the giving flow: surface background, light shadow,
 * no borders, consistent padding/spacing.
 */
export default function GivingCard({ children, title, testID, style, surfaceColor = null, textColor = null }) {
    return (
        <View testID={testID} style={[styles.card, surfaceColor && { backgroundColor: surfaceColor }, style]}>
            {!!title && <Text style={[styles.title, textColor && { color: textColor }]}>{title}</Text>}
            {children}
        </View>
    );
}

const styles = StyleSheet.create(({ colors, fonts, spacing, roundness, shadows, typography }) => ({
    card: {
        borderRadius: roundness.md,
        padding: spacing.md,
        backgroundColor: colors.surface,
        boxShadow: shadows.card,
        gap: spacing.sm,
    },
    title: {
        fontSize: typography.h3,
        fontFamily: fonts.heading,
        color: colors.text,
    },
}));
